import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import Nav from '../components/Nav'
import Footer from '../components/Footer'

const News = () => {
  const [isLoading, setIsLoading] = useState(true);

  // Simulating an API or data fetching process
  useEffect(() => {
    const loadData = async () => {
      // Simulate network delay
      await new Promise(resolve => setTimeout(resolve, 2000));
      setIsLoading(false);
    };
    loadData();
  }, []);

  return (
    <>
      <Nav />
      <div className="min-h-screen flex justify-center items-center bg-gray-100">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div className="text-5xl p-40 m-40 font-semibold uppercase text-center">
            <h1>News</h1>
          </div>
        )}
      </div>
      <Footer />
    </>
  )
}

export default News